import TableTools from "@/utils/tableTools";
import dimensionEnum from "@/model/dimensionEnum";
import {
  columnTypeEnum,
} from "@/model/columnsEnums";
import { staffHelper } from "@/utils/staffHelper";
import { staffHistoryHelper } from "@/utils/staffHistoryHelper";
import { StaffViewsEnum } from "@/utils/staffEnum";
import { dateFormatEnum } from "@/filter/dateFormat";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    dimensionColumnsTables: [],
    measureColumnsTables: [],
    defaultSortedColumnTables: "",
    tablesData: [],
    dataReadyTables: false,
  },
  mutations: {
    setDimensionColumnsTables(state, data) {
      state.dimensionColumnsTables = data;
    },
    setMeasureColumnsTables(state, data) {
      state.measureColumnsTables = data;
    },
    setDefaultSortedColumnTables(state, data) {
      state.defaultSortedColumnTables = data;
    },
    setTablesData(state, data) {
      state.tablesData = data;
    },
    updateTableData(state, payload) {
      state.tablesData = state.tablesData.map(tab => {
        if (tab.tableHeaderId === payload.siteId) {
          return { ...tab, dataTable: payload.dataTable, totalsData: payload.totalsData }
        }
        return tab;
      });
    },
    setDataReadyTables(state, data) {
      state.dataReadyTables = data;
    },
  },
  actions: {
    resetDataReadyTables({ commit }) {
      commit("setDataReadyTables", false);
    },
    initDisplayTables({ commit }, payload) {
      const { dimensions, measures, siteCurrency } = payload;

      commit("setDimensionColumnsTables", TableTools.Helper.constructColumnTable(
        dimensions,
        null,
        columnTypeEnum.DIMENSION,
        true,
        null
      ));

      commit("setMeasureColumnsTables", TableTools.Helper.constructColumnTable(
        measures,
        null,
        columnTypeEnum.MEASURE,
        true,
        null,
        false,
        siteCurrency
      ));

      commit("setDefaultSortedColumnTables", dimensionEnum.EMPLOYEE_LASTNAME);
    },
    async updateTableList({ state, commit, dispatch }, payload) {
      // Initialisation des objets contenant toutes les données pour chaque site :
      // permet d'afficher dès maintenant les entêtes de tableaux et le loader pour indiquer que les requêtes sont en cours
      const tablesData = payload.siteValues.map((site, i) => {
        return {
          tableNumber: i.toString(),
          tableHeader: site.label,
          tableHeaderId: site.id,
          dataTable: [],
          totalsData: {},
        };
      });
      commit("setTablesData", tablesData);

      let mergedResults = null;

      // Requête si la vue est Historique staff
      if (payload.staffView === StaffViewsEnum.staffHistory) {
        const query = staffHistoryHelper.getQuery(payload.filters);
        if (payload.timeDimension) {
          query.timeDimensions = [payload.timeDimension];
        }
        mergedResults = await TableTools.Helper.doRequest(query);
      }

      // Requêtes si la vue est Rapport staff
      if (payload.staffView === StaffViewsEnum.staffReport) {
        const queries = staffHelper.getQueries(payload.filters);
        // Injecter timeDimensions dans chaque query
        if (payload.timeDimension) {
          queries.forEach(q => {
            q.query.timeDimensions = [payload.timeDimension];
          });
        }
        const resultSets = await TableTools.Helper.doMultipleRequest(queries);
        mergedResults = TableTools.Helper.mergeResultsByCommonDimensions(
          resultSets,
          staffHelper.dimensions
        );
      }
      if (
        payload.staffView == null ||
        ![StaffViewsEnum.staffHistory, StaffViewsEnum.staffReport].includes(payload.staffView)
      ) {
        console.error("No staffViewsEnum given or not filled in");
      }

      // Extraire la première devise pour les labels de colonnes
      const defaultCurrency = mergedResults && mergedResults.length > 0 ? (mergedResults[0][dimensionEnum.SITE_CURRENCY] || 'EUR') : 'EUR';
      await dispatch('initDisplayTables', {
        dimensions: payload.dimensions || staffHelper.dimensions,
        measures: payload.measures || [],
        siteCurrency: defaultCurrency
      });

      // Complétion des objets avec les données reçues pour chaque site
      payload.siteValues.forEach((site) => {
        const dataTable = mergedResults.filter(
          (result) => result[dimensionEnum.SITE] === site.id
        );

        // Extraire la devise spécifique à ce site
        const siteCurrency = dataTable.length > 0 ? (dataTable[0][dimensionEnum.SITE_CURRENCY] || 'EUR') : 'EUR';

        // Ajouter la devise à chaque ligne pour le formatage
        dataTable.forEach(row => {
          row["Site.currency"] = siteCurrency;
        });

        let totalsData = null;
        if (payload.staffView === StaffViewsEnum.staffReport) {
          totalsData = TableTools.Helper.calculateTotalsData(
            dataTable,
            state.measureColumnsTables.map((col) => col.key)
          );
          totalsData = staffHelper.addDimensionsTotals(dataTable, totalsData);
        }
        commit("updateTableData", { siteId: site.id, dataTable, totalsData });
      });

      commit("setDataReadyTables", true);
    },
  },
};
